import { render, staticRenderFns } from "./sponsor-examine.vue?vue&type=template&id=bd7e9db8"
import script from "./sponsor-examine.vue?vue&type=script&lang=js"
export * from "./sponsor-examine.vue?vue&type=script&lang=js"
import style0 from "./sponsor-examine.vue?vue&type=style&index=0&id=bd7e9db8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports